import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import moment from "moment";
import { setCKEditorPrincipalColorPalette } from "@/helpers/commonHelper";

Vue.use(VueRouter);

const COST_MANAGEMENT_PRINCIPAL_ID = "00000000-0000-0000-1000-000000000001";

const routes = [
  {
    path: "/",
    name: "EO.Heimat",
    component: () =>
      import(/* webpackChunkName: "Home" */ "@/views/Home/Home.vue")
  },
  {
    path: "/anzeigenassistent",
    name: "Anzeigenassistent",
    component: () =>
      import(
        /* webpackChunkName: "LayoutWizard" */ "@/views/LayoutWizard/LayoutWizard/LayoutWizard.vue"
      )
  },
  {
    path: "/anzeigenassistent/service_providers",
    name: "Anzeigenassistent: Leistungsträger",
    component: () =>
      import(
        /* webpackChunkName: "LayoutWizardServiceprovider" */ "@/views/LayoutWizard/LayoutWizardServiceprovider/LayoutWizardServiceprovider.vue"
      )
  },
  {
    path: "/anzeigenassistent/service_providers/update/:id",
    name: "Anzeigenassistent: Leistungsträger bearbeiten",
    component: () =>
      import(
        /* webpackChunkName: "LayoutWizardServiceprovider" */ "@/views/LayoutWizard/LayoutWizardServiceprovider/LayoutWizardServiceprovider.vue"
      ),
    props: route => ({ update: route.params.id })
  },
  {
    path: "/anzeigenassistent/advertisements",
    name: "Anzeigenassistent: Anzeigen",
    component: () =>
      import(
        /* webpackChunkName: "LayoutWizardAdvertisement" */ "@/views/LayoutWizard/LayoutWizardAdvertisement/LayoutWizardAdvertisement.vue"
      )
  },
  {
    path: "/anzeigenassistent/config",
    name: "Anzeigenassistent: Administration",
    component: () =>
      import(
        /* webpackChunkName: "LayoutWizardConfig" */ "@/views/LayoutWizard/LayoutWizardConfig/LayoutWizardConfig.vue"
      )
  },
  {
    path: "/news",
    name: "Nachrichten Manager",
    component: () =>
      import(/* webpackChunkName: "News" */ "@/views/News/News/News.vue")
  },
  {
    path: "/news/news",
    name: "Nachrichten Manager: Nachrichten",
    component: () =>
      import(
        /* webpackChunkName: "NewsList" */ "@/views/News/NewsList/NewsList.vue"
      )
  },
  {
    path: "/news/news/update/:id",
    name: "Nachrichten Manager: Nachrichten bearbeiten",
    component: () =>
      import(
        /* webpackChunkName: "NewsList" */ "@/views/News/NewsList/NewsList.vue"
      ),
    props: route => ({ update: route.params.id })
  },
  {
    path: "/news/issues",
    name: "Nachrichten: Ausgaben",
    component: () =>
      import(
        /* webpackChunkName: "NewsIssues" */ "@/views/News/NewsIssues/NewsIssues.vue"
      )
  },
  {
    path: "/news/app-statistics",
    name: "Nachrichten: APP Statistik",
    component: () =>
      import(
        /* webpackChunkName: "NewsAppStatisticsOverview" */ "@/views/News/NewsAppStatisticsOverview/NewsAppStatisticsOverview.vue"
      )
  },
  {
    path: "/news/app-content-types",
    name: "Nachrichten: APP Seiten",
    component: () =>
      import(
        /* webpackChunkName: "NewsAppContentTypes" */ "@/views/News/NewsAppContentTypes/NewsAppContentTypes.vue"
      )
  },
  {
    path: "/news/app-push-messages",
    name: "Nachrichten: APP Push-Nachrichten",
    component: () =>
      import(
        /* webpackChunkName: "NewsAppPushMessages" */ "@/views/News/NewsAppPushMessages/NewsAppPushMessages.vue"
      )
  },
  {
    path: "/news/config",
    name: "Nachrichten: Administration",
    component: () =>
      import(
        /* webpackChunkName: "NewsAdmin" */ "@/views/News/NewsAdmin/NewsAdmin.vue"
      )
  },
  {
    path: "/news/feature-groups",
    name: "Nachrichten: Merkmalsgruppen",
    component: () =>
      import(
        /* webpackChunkName: "NewsFeatureGroups" */ "@/views/News/NewsFeatureGroups/NewsFeatureGroups.vue"
      )
  },
  {
    path: "/news/features",
    name: "Nachrichten: Merkmale",
    component: () =>
      import(
        /* webpackChunkName: "NewsFeatures" */ "@/views/News/NewsFeatures/NewsFeatures.vue"
      )
  },
  {
    path: "/news/statistics",
    name: "Nachrichten: Statistiken",
    component: () =>
      import(
        /* webpackChunkName: "NewsStatistics" */ "@/views/News/NewsStatistics/NewsStatistics.vue"
      )
  },
  {
    path: "/news/statistics/overview",
    name: "Nachrichten: Übersicht",
    component: () =>
      import(
        /* webpackChunkName: "NewsOverview" */ "@/views/News/NewsStatistics/NewsOverview/NewsOverview.vue"
      )
  },
  {
    path: "/news/workflow",
    name: "Eingang & Freigabe",
    component: () =>
      import(
        /* webpackChunkName: "NewsWorkflow" */ "@/views/News/NewsWorkflow/NewsWorkflow.vue"
      )
  },
  {
    path: "/locations/",
    name: "Ortsdatenbank Übersicht",
    component: () =>
      import(
        /* webpackChunkName: "LocationsOverview" */ "@/views/Locations/LocationsOverview/LocationsOverview.vue"
      )
  },
  {
    path: "/locations/locations",
    name: "Ortsdatenbank",
    component: () =>
      import(
        /* webpackChunkName: "Locations" */ "@/views/Locations/Locations.vue"
      )
  },
  {
    path: "/locations/config",
    name: "Ortsdatenbank: Konfiguration",
    component: () =>
      import(
        /* webpackChunkName: "Locations" */ "@/views/Locations/Admin/Admin.vue"
      )
  },
  {
    path: "/locations/features",
    name: "Ortsdatenbank: Merkmale",
    component: () =>
      import(
        /* webpackChunkName: "Locations" */ "@/views/Locations/Features/Features.vue"
      )
  },
  {
    path: "/poi",
    name: "Points of Interest: Übersicht",
    component: () =>
      import(
        /* webpackChunkName: "PoiOverview" */ "@/views/POI/POIS/PoiOverview/PoiOverview.vue"
      )
  },
  {
    path: "/poi/config",
    name: "Points of Interest: Administration",
    component: () =>
      import(
        /* webpackChunkName: "POIAdmin" */ "@/views/POI/POIS/POIAdmin/POIAdmin.vue"
      )
  },
  {
    path: "/poi/config/features",
    name: "Points of Interest: Merkmale",
    component: () =>
      import(
        /* webpackChunkName: "FeatureConfig" */ "@/views/Events/FeatureConfig/FeatureConfig.vue"
      )
  },
  {
    path: "/poi/widget",
    name: "POI Widget: Administration",
    component: () =>
      import(
        /* webpackChunkName: "POIWidget" */ "@/views/POI/POIWidget/POIWidget.vue"
      )
  },
  {
    path: "/poi/region",
    name: "Regionen",
    component: () =>
      import(
        /* webpackChunkName: "PoiRegions" */ "@/views/POI/Regions/Regions.vue"
      )
  },
  {
    path: "/poi-region-edit",
    name: "Skigebiet/Ort Pois",
    component: () =>
      import(
        /* webpackChunkName: "POIRegionEdit" */ "@/views/POI/POIRegionEdit/POIRegionEdit.vue"
      )
  },
  {
    path: "/poi/poi-managed-board",
    name: "Points of Interest: Managed Board",
    component: () => import("@/views/POI/POIManagedBoard/POIManagedBoard.vue")
  },
  {
    path: "/poi/statistics",
    name: "POI: Statistiken",
    component: () =>
      import(
        /* webpackChunkName: "POIStatistics" */ "@/views/POI/POIStatistics/POIStatistics.vue"
      )
  },
  {
    path: "/poi/statistics/overview",
    name: "POIs: Übersicht",
    component: () =>
      import(
        /* webpackChunkName: "POIOverview" */ "@/views/POI/POIStatistics/POIOverview/POIOverview.vue"
      )
  },
  {
    path: "/poi/config/categories",
    name: "Points of Interest: Kategorien",
    component: () =>
      import(
        /* webpackChunkName: "GlobalCategoryConfig" */ "@/views/POI/GlobalCategoryConfig/GlobalCategoryConfig.vue"
      )
  },
  {
    path: "/poi/config/mappingfields",
    name: "Points of Interest: Mapping-Felder",
    component: () =>
      import(
        /* webpackChunkName: "GlobalCategoryConfig" */ "@/views/POI/POIS/POIMappingFields/POIMappingFields.vue"
      )
  },
  {
    path: "/poi/config/widget",
    name: "Globale Widget Config",
    component: () =>
      import(
        /* webpackChunkName: "GlobalWidgetConfig" */ "@/views/POI/GlobalWidgetConfig/GlobalWidgetConfig.vue"
      )
  },
  {
    path: "/poi/pois/:id?",
    name: "Points of Interest",
    component: () =>
      import(/* webpackChunkName: "POI" */ "@/views/POI/POI.vue"),
    props: route => ({ editId: route.params.id ?? false })
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "Login" */ "@/views/Login/Login.vue"),
    props: true
  },
  {
    path: "/changePw/:secret?",
    name: "ChangePw",
    component: () =>
      import(
        /* webpackChunkName: "changePw" */ "@/views/Admin/ChangePw/ChangePw.vue"
      ),
    props: route => ({ secret: route.params.secret ?? false })
  },
  {
    path: "/admin",
    name: "Admin",
    component: () =>
      import(/* webpackChunkName: "Admin" */ "@/views/Admin/Admin/Admin.vue")
  },
  {
    path: "/admin/principals",
    name: "Admin: Mandanten",
    component: () =>
      import(
        /* webpackChunkName: "PrincipalsAdmin" */ "@/views/Admin/PrincipalsAdmin/PrincipalsAdmin.vue"
      )
  },
  {
    path: "/admin/groups",
    name: "Admin: Gruppen",
    component: () =>
      import(
        /* webpackChunkName: "GroupsAdmin" */ "@/views/Admin/GroupsAdmin/GroupsAdmin.vue"
      )
  },
  {
    path: "/admin/users",
    name: "Admin: Benutzer",
    component: () =>
      import(
        /* webpackChunkName: "UserAdmin" */ "@/views/Admin/UserAdmin/UserAdmin.vue"
      )
  },
  {
    path: "/admin/clients",
    name: "Admin: OAuth2-Clients",
    component: () =>
      import(
        /* webpackChunkName: "ClientAdmin" */ "@/views/Admin/ClientAdmin/ClientAdmin.vue"
      )
  },
  {
    path: "/admin/third-party-systems",
    name: "Admin: Fremdsysteme",
    component: () =>
      import(
        /* webpackChunkName: "ThirdPartySystemsAdmin" */ "@/views/Admin/ThirdPartySystemsAdmin/ThirdPartySystemsAdmin.vue"
      )
  },
  {
    path: "/admin/globalConfig",
    name: "Admin: Globale Konfiguration",
    component: () =>
      import(
        /* webpackChunkName: "ThirdPartySystemsAdmin" */ "@/views/Admin/GlobalConfig/GlobalConfig.vue"
      )
  },
  {
    path: "/forms",
    name: "Forms Übersicht",
    component: () =>
      import(
        /* webpackChunkName: "FormOverview" */ "@/views/Forms/FormOverview.vue"
      )
  },
  {
    path: "/forms/builder",
    name: "Formular Editor",
    component: () =>
      import(
        /* webpackChunkName: "FormBuilder" */ "@/views/Forms/FormBuilder.vue"
      )
  },
  {
    path: "/forms/submissions",
    name: "Formulareinreichungen",
    component: () =>
      import(
        /* webpackChunkName: "FormSubmissions" */ "@/views/Forms/FormSubmissions/FormSubmissions.vue"
      )
  },
  {
    path: "/web2print",
    name: "Web2Print",
    component: () =>
      import(
        /* webpackChunkName: "Web2Print" */ "@/views/Web2Print/Web2Print.vue"
      )
  },
  {
    path: "/typo3",
    name: "Content Management",
    component: () =>
      import(/* webpackChunkName: "Typo3" */ "@/views/Typo3/Typo3.vue")
  },
  {
    path: "/events",
    name: "Veranstaltungen",
    component: () =>
      import(
        /* webpackChunkName: "EventsOverview" */ "@/views/Events/EventsOverview/EventsOverview.vue"
      )
  },
  {
    path: "/events/events/:editId?",
    name: "Veranstaltungen: Liste",
    component: () =>
      import(
        /* webpackChunkName: "EventList" */ "@/views/Events/EventList/EventList.vue"
      ),
    props: true
  },
  {
    path: "/events/oplocs/:editId?",
    name: "Veranstaltungen: Veranstalter & Standorte",
    component: () =>
      import(
        /* webpackChunkName: "EventOrganizerList" */ "@/views/Events/EventOrganizerList/EventOrganizerList.vue"
      ),
    props: true
  },
  {
    path: "/events/app-content-types",
    name: "Veranstaltungen: APP Seiten",
    component: () =>
      import(
        /* webpackChunkName: "EventsAppContentTypes" */ "@/views/Events/EventsAppContentTypes/EventsAppContentTypes.vue"
      )
  },
  {
    path: "/events/config",
    name: "Veranstaltungen: Administration",
    component: () =>
      import(
        /* webpackChunkName: "EventAdmin" */ "@/views/Events/EventAdmin/EventAdmin.vue"
      )
  },
  {
    path: "/events/duplicates",
    name: "Veranstaltungen: Duplikatcheck",
    component: () =>
      import(
        /* webpackChunkName: "EventAdmin" */ "@/views/Events/EventAdminDuplicates/EventAdminDuplicates.vue"
      )
  },
  {
    path: "/events/config/categories",
    name: "Veranstaltungen: Kategorien",
    component: () =>
      import(
        /* webpackChunkName: "EventAdminCategories" */ "@/views/Events/EventAdminCategories/EventAdminCategories.vue"
      )
  },
  {
    path: "/events/config/Features",
    name: "Veranstaltungen: Merkmale",
    component: () =>
      import(
        /* webpackChunkName: "EventAdminFeatures" */ "@/views/Events/EventAdminFeatures/EventAdminFeatures.vue"
      )
  },
  {
    path: "/events/workflow",
    name: "Eingang & Freigabe",
    component: () =>
      import(
        /* webpackChunkName: "EventWorkflow" */ "@/views/Events/EventWorkflow/EventWorkflow.vue"
      )
  },
  {
    path: "/events/statistics",
    name: "Statistiken",
    component: () =>
      import(
        /* webpackChunkName: "EventStatistics" */ "@/views/Events/EventStatistics/EventStatistics.vue"
      )
  },
  {
    path: "/events/statistics/overview",
    name: "Veranstaltungen: Übersicht",
    component: () =>
      import(
        /* webpackChunkName: "EventOverview" */ "@/views/Events/EventStatistics/EventOverview/EventOverview.vue"
      )
  },
  {
    path: "/kis",
    name: "Kommunales Informationssystem",
    component: () =>
      import(
        /* webpackChunkName: "KisOverview" */ "@/views/KIS/KisOverview/KisOverview.vue"
      )
  },
  {
    path: "/kis/departments",
    name: "Geschäftsbereiche",
    component: () =>
      import(
        /* webpackChunkName: "KisDepartmentList" */ "@/views/KIS/KisDepartmentList/KisDepartmentList.vue"
      )
  },
  {
    path: "/kis/persons",
    name: "Personen",
    component: () =>
      import(
        /* webpackChunkName: "KisPersonList" */ "@/views/KIS/KisPersonList/KisPersonList.vue"
      )
  },
  {
    path: "/kis/tasks",
    name: "Dienstleistungen",
    component: () =>
      import(
        /* webpackChunkName: "KisPersonList" */ "@/views/KIS/KisTasks/KisTasks.vue"
      )
  },
  {
    path: "/kis/subjectareas",
    name: "Referate",
    component: () =>
      import(
        /* webpackChunkName: "KisPersonList" */ "@/views/KIS/KisSubjectArea/KisSubjectArea.vue"
      )
  },
  {
    path: "/kis/facilities",
    name: "Einrichtungen",
    component: () =>
      import(
        /* webpackChunkName: "KisFacilityList" */ "@/views/KIS/KisFacilityList/KisFacilityList.vue"
      )
  },
  {
    path: "/kis/committees",
    name: "Gremien",
    component: () =>
      import(
        /* webpackChunkName: "KisCommitteeList" */ "@/views/KIS/KisCommitteeList/KisCommitteeList.vue"
      )
  },
  {
    path: "/defects",
    name: "Mängel",
    component: () =>
      import(
        /* webpackChunkName: "KisDefectOverview" */ "@/views/KIS/KisDefectOverview/KisDefectOverview.vue"
      )
  },
  {
    path: "/defects/defects",
    name: "Mängelliste: Liste",
    component: () =>
      import(
        /* webpackChunkName: "KisDefect" */ "@/views/KIS/KisDefect/KisDefect.vue"
      )
  },
  {
    path: "/defects/defects/:id?",
    name: "Mängelliste",
    component: () =>
      import(
        /* webpackChunkName: "KisDefect" */ "@/views/KIS/KisDefect/KisDefect.vue"
      ),
    props: route => ({ editId: route.params.id ?? false })
  },
  {
    path: "/defects/defectCategories",
    name: "Melde-Kategorien",
    component: () =>
      import(
        /* webpackChunkName: "KisDefectCategories" */ "@/views/KIS/KisDefectCategories/KisDefectCategories.vue"
      )
  },
  {
    path: "/defects/config",
    name: "Mängel Administration",
    component: () =>
      import(
        /* webpackChunkName: "KisAdmin" */ "@/views/KIS/KisAdmin/KisAdmin.vue"
      )
  },
  {
    path: "/kis/config",
    name: "Kis Administration",
    component: () =>
      import(
        /* webpackChunkName: "KisAdmin" */ "@/views/KIS/KisAdmin/KisAdmin.vue"
      )
  },
  {
    path: "/booking",
    name: "Booking Übersicht Administration",
    component: () =>
      import(
        /* webpackChunkName: "BookingOverview" */ "@/views/LastMinute/BookingOverview/BookingOverview.vue"
      )
  },
  {
    path: "/booking/servicepackages",
    name: "Booking Übersicht Last-Minute Angebote",
    component: () =>
      import(
        /* webpackChunkName: "BookingServicepackages" */ "@/views/LastMinute/BookingServicePackagesList/BookingServicePackagesList.vue"
      )
  },
  {
    path: "/booking/accommodationtypes",
    name: "Booking Unterkunftsarten",
    component: () =>
      import(
        /* webpackChunkName: "BookingAccommodationTypes" */ "@/views/LastMinute/BookingAccommodationTypes/BookingAccommodationTypes.vue"
      )
  },
  {
    path: "/booking/features",
    name: "Booking Merkmale",
    component: () =>
      import(
        /* webpackChunkName: "BookingFeatures" */ "@/views/LastMinute/BookingFeatureList/BookingFeatureList.vue"
      )
  },
  {
    path: "/booking/config",
    name: "Booking Administration",
    component: () =>
      import(
        /* webpackChunkName: "BookingConfig" */ "@/views/LastMinute/BookingAdmin/BookingAdmin.vue"
      )
  },
  {
    path: "/user/settings",
    name: "Benutzereinstellungen",
    component: () =>
      import(
        /* webpackChunkName "UserEditDialog" */ "@/views/Admin/UserEditDialog/UserEditDialog.vue"
      )
  },
  {
    path: "/llms",
    name: "LLM Übersicht",
    component: () =>
      import(
        /* webpackChunkName "LlmOverview" */ "@/views/LLM/LlmOverview/LlmOverview.vue"
      )
  },
  {
    path: "/llms/api-settings",
    name: "Provider",
    component: () =>
      import(
        /* webpackChunkName "APIManagement" */ "@/views/LLM/APIManagement/APIManagement.vue"
      )
  },
  {
    path: "/llms/prompt-settings",
    name: "Prompt Einstellungen",
    component: () =>
      import(
        /* webpackChunkName "PromptManagement" */ "@/views/LLM/PromptManagement/PromptManagement.vue"
      )
  },
  {
    path: "/llms/feed-settings",
    name: "Feed Einstellungen",
    component: () =>
      import(
        /* webpackChunkName "PromptManagement" */ "@/views/LLM/FeedManagement/FeedManagement.vue"
      )
  },
  {
    path: "/llms/mapping",
    name: "Mapping",
    component: () =>
      import(/* webpackChunkName "Mapping" */ "@/views/LLM/Mapping/Mapping.vue")
  },
  {
    path: "/llms/rag",
    name: "RAG",
    component: () =>
      import(
        /* webpackChunkName "RAG" */ "@/views/LLM/RAGManagement/RAGManagement.vue"
      )
  },
  {
    path: "/llms/stats",
    name: "Auswertung",
    component: () =>
      import(/* webpackChunkName "LlmStats" */ "@/views/LLM/Stats/Stats.vue")
  },
  {
    path: "/llms/cost-management",
    name: "Kostenmanagement",
    meta: {
      restrictedPrincipalId: COST_MANAGEMENT_PRINCIPAL_ID
    },
    component: () =>
      import(
        /* webpackChunkName "CostManagement" */ "@/views/LLM/CostManagement/CostManagement.vue"
      )
  },
  {
    path: "/admin/cronjob-management",
    name: "Verwaltung CronJobs",
    component: () =>
      import(
        /* webpackChunkName "CronJobManagement" */ "@/views/Admin/CronJobManagement/CronJobManagement.vue"
      )
  },
  {
    path: "/llms/administration",
    name: "LLM Administration",
    component: () =>
      import(
        /* webpackChunkName "LLMAdmin" */ "@/views/LLM/Administration/LLMAdmin.vue"
      )
  },
  {
    path: "/admanager",
    name: "AdManager Übersicht",
    component: () =>
      import(
        /* webpackChunkName "AdmanagerOverview" */ "@/views/AdManager/AdManagerOverview/AdManagerOverview.vue"
      )
  },
  {
    path: "/admanager/formats",
    name: "AdManager Formate",
    component: () =>
      import(
        /* webpackChunkName "AdManagerFormats" */ "@/views/AdManager/AdManagerFormats/AdManagerFormats.vue"
      )
  },
  {
    path: "/admanager/banners",
    name: "AdManager Banner",
    component: () =>
      import(
        /* webpackChunkName "AdManagerBanners" */ "@/views/AdManager/AdManagerBanners/AdManagerBanners.vue"
      )
  },
  {
    path: "/admanager/zone",
    name: "AdManager Werbezone",
    component: () =>
      import(
        /* webpackChunkName "AdManagerAdvertisingZone" */ "@/views/AdManager/AdManagerAdvertisingZone/AdManagerAdvertisingZone.vue"
      )
  },
  {
    path: "/admanager/group",
    name: "AdManager Werbezonengruppe",
    component: () =>
      import(
        /* webpackChunkName "AdManagerAdvertisingZoneGroup" */ "@/views/AdManager/AdManagerAdvertisingZoneGroup/AdManagerAdvertisingZoneGroup.vue"
      )
  },
  {
    path: "/admanager/config",
    name: "AdManager: Administration",
    component: () =>
      import(
        /* webpackChunkName: "AdManagerAdmin" */ "@/views/AdManager/AdManagerAdmin/AdManagerAdmin.vue"
      )
  },
  {
    path: "/maps",
    name: "Maps: Übersicht",
    component: () =>
      import(
        /* webpackChunkName: "MapsOverview" */ "@/views/Maps/MapsOverview/MapsOverview.vue"
      )
  },
  {
    path: "/maps/config",
    name: "Maps: Administration",
    component: () =>
      import(
        /* webpackChunkName: "MapsAdmin" */ "@/views/Maps/MapsAdmin/MapsAdmin.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name === "ChangePw") {
    next();
    return;
  }
  const session = store.state.session?.id,
    expires = moment(store.state.session?.expires);
  if (to.name !== "Login" && (!session || expires.isBefore(moment())))
    next({
      name: "Login",
      params: { prev: to.name === "Login" ? from.path : to.path }
    });
  else if (
    to.meta?.restrictedPrincipalId &&
    store.state.selectedPrincipal?.id !== to.meta.restrictedPrincipalId
  )
    next({ name: "LLM Übersicht" });
  else if (to.name === "Login" && session && expires.isAfter(moment()))
    next({ name: "EO.Heimat" });
  else if (store.state.modules === "regionEdit") next("/poi-region-edit");
  else next();
});

router.afterEach(setCKEditorPrincipalColorPalette);

export default router;
